export default "__VITE_ASSET__Cep0hg3j__"